export default __webpack_public_path__ + "static/media/file8.697aa391.jpg";